const $arFilesUpload = $('.js-files-upload');

class FilesUpload {
    constructor (container) {
        this.$container = $(container);
        this.$totalSizeContainer = this.$container.find('.js-files-total-size');
        this.$field = this.$container.find('.file-input');
        this.$input = this.$field.find('.js-file-input');
        this.countFiles = 1;
        this.maxFilesAllowed = parseInt(this.$container.data('max-files')) || 10;
        this.maxFilesSizesMB = parseInt(this.$container.data('max-all-size-mb')) || 100; 
        this.extensionsAllowed = this.$container.data('allow-extensions').split(',') || [];
    }

    init () {
        this.addListener(this.$field);
    }

    checkField (file) {
        const ext = file.name.split('.').pop().toLowerCase();

        if (this.extensionsAllowed.length > 1 && this.extensionsAllowed.indexOf(ext) < 0) {
            alert(localize({
                'ru': `Файл ${file.name} не поддерживаемого расширения!`,
                'en': `This file extension ${file.name} is not supported!`
            }));
            return false;
        }

        return true;
    }

    addListener ($field) {
        const self = this;

        $field
            .on('click', '.file-input__remove', function() {
                self.removeField($field);

                if (self.countFiles == self.$container.find('.file-input[data-filled=true]').length) {
                    self.addField();
                }

                self.updateTotalFilesSize();
            });

        $field
            .find('.js-file-input')
            .on('change', function () {
                const $fileInput = this.closest('.file-input');
                const $label = $fileInput.querySelector('.file-input__label');
                const $lastField = self.$container.find('.file-input:last');

                if (!self.checkField($(this).prop('files')[0])) return false;
                if (!self.updateTotalFilesSize()) return false;

                if (this.files.length == 1) {
                    $fileInput.setAttribute('data-filled', 'true');

                    if (self.countFiles < self.maxFilesAllowed && ($lastField.attr('data-filled') == 'true')) {
                        self.addField();
                    }

                    $label.innerText = localize({
                        'ru': `${this.files[0].name} [${(this.files[0].size/1024/1024).toFixed(2)} Мб]`,
                        'en': `${this.files[0].name} [${(this.files[0].size/1024/1024).toFixed(2)} MB]`
                    })
                } else {
                    $label.innerText = localize({
                        'ru': 'Файл не выбран',
                        'en': 'File not selected'
                    })

                    $fileInput.setAttribute('data-filled', 'false');
                }
            });
    }

    addField () {
        const $fieldNext = this.templateHTMLFile();

        $($fieldNext).insertAfter(this.$container.find('.file-input:last'));

        this.addListener(this.$container.find('.file-input:last'));
        this.countFiles++;
    }

    clearField ($field) {
        $field.find('.js-file-input').val('');
        $field.find('.file-input__label').text(localize({
            'ru': 'Файл не выбран',
            'en': 'File not selected'
        }));
        $field.attr('data-filled', 'false');
    }

    removeField ($field) {
        const $arInputs = $field.closest('.form__valid-container').find('.js-file-input');

        $field.remove();
        this.countFiles--;

        if ($arInputs.length <= 2 && this.$input.attr('data-rule-required')) {
            checkValidtaionEl($arInputs.last().attr('data-rule-required', true));
            $arInputs
                .last()
                .rules("add", {
                    required: true
                })
        }
    }

    templateHTMLFile (i) {
        const emptyText = localize({
                    'ru': 'Файл не выбран',
                    'en': 'File not selected'
                }),
                errorText = localize({
                    'ru': 'Поле обязательно для заполнения',
                    'en': 'The field is required'
                }),
                addText = localize({
                    'ru': 'Добавить файл',
                    'en': 'Add a file'
                }),
                name = this.$input.attr('name');
        
        const arLastInputId = this.$container.find('.js-file-input').last().attr('id').split('-')

        return `
            <div class="file-input">
                <label class="file-input__btn">
                    <input
                        type="file"
                        id="file-upload-${parseInt(arLastInputId[arLastInputId.length-1]) + 1}"
                        class="js-file-input file-input__area"
                        name="${name}"
                        ${this.$input.attr('data-rule-required') ? `data-rule-required="false" data-msg-required="${errorText}"` : ''}
                    >
                    ${addText}
                </label>
                <span class="file-input__label">${emptyText}</span>
                <span class="file-input__remove"></span>
            </div>
        `;
    }

    updateTotalFilesSize () {
        let totalSize = 0;

        this.$container
            .find('input[type=file]')
            .each(function (b, a) {
                if (typeof $(a).prop('files')[0] != 'undefined' && $(a).prop('files')[0]!=null) {
                    totalSize += $(a).prop('files')[0].size;
                }
            });

        totalSize = totalSize/1024/1024;

        if (totalSize > this.maxFilesSizesMB) {
            alert(localize({
                'ru': `Общий размер размещаемых файлов по заявке не должен превышать ${this.maxFilesSizesMB} Мб`,
                'en': `Attachment size must not exceed ${this.maxFilesSizesMB} MB in total`
            }));
            return false;
        }

        this.$totalSizeContainer.html(totalSize.toFixed(2));
        return true;
    }
}

$arFilesUpload.each(function (i, el) {
    new FilesUpload(el).init();
})



// WEBPACK FOOTER //
// ./frontend/components/files-upload/files-upload.js